<div class="Boton_Hover">
    <qrcode #parent (qrCodeURL)="onChangeURL($event)" [colorDark]="ColorQR === '#FFFFFF' ? '000' : ColorQR || '#BC7E01'" elementType="img" [qrdata]="getUrlQR(ContenidoQR)" [width]="128" margin="1" [errorCorrectionLevel]="'M'"></qrcode>
    <button mat-mini-fab color="primary"><a (click)="saveAsImage(parent)"><mat-icon>download</mat-icon></a></button>
</div>